// extracted by mini-css-extract-plugin
export default {"wrapper":"PostList_wrapper__k7BNs","title":"PostList_title__FQUTt","content":"PostList_content__sS-v4"};